/**
 * Coup de pouce, Attendu 1228 « calculer la valeur d'une expression
 * algébrique avec des puissances ou non » (3e, Calcul littéral, l. 796).
 * Seconde passe 3e (2026-09-13). DEUX pages STATIQUES, une par piège,
 * partagées par les trois clés ; le geste de base (remplacer la lettre par
 * le nombre, 4e, fiche 1111) est écrit sur chacune.
 *   « Avec un carré » : 3x² pour x = 4. Je remplace x par 4 : 3 × 4². Le
 *     carré d'abord : 4² = 16, puis 3 × 16 = 48 (contre (3 × 4)² = 144).
 *   « Avec un x négatif » : 2x + 5 pour x = −3. Je remplace x par (−3),
 *     entre parenthèses : 2 × (−3) + 5 = −6 + 5 = −1 (contre 6 + 5 = 11).
 *
 * SACRIFIÉS (gen_1228, gen1228.self.test.js) : (3x² ; 4), ((3x)² ; 4),
 * (2x + 5 ; −3), 3x + 2 pour tout x (importé de 1111).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const gras = (t, couleur = ENCRE) => `<tspan font-weight="bold" fill="${couleur}">${t}</tspan>`;

// ─── Page 1 : 3x² pour x = 4 ───────────────────────────────────────────────

const SVG_CARRE = svg(
    '3x au carré pour x égale 4. Je remplace x par 4 : 3 fois 4 au carré. Le carré d’abord : 4 au carré égale 16. Puis 3 fois 16 égale 48. Le carré ne porte que sur le 4, pas sur 3 fois 4.',
    `<!-- 1. l'expression et la valeur -->
  ${ligne(40, `3${gras('x', BLEU)}² pour ${gras('x', BLEU)} = ${gras('4', ORANGE)}`, 18)}

  <!-- 2. je remplace -->
  ${ligne(80, `3 × ${gras('4', ORANGE)}²`, 20)}
  ${ligne(100, `je remplace ${gras('x', BLEU)} par ${gras('4', ORANGE)}`, 11, GRIS)}

  <!-- 3. le carré d'abord -->
  ${ligne(138, `3 × ${gras('16')}`, 20)}
  ${ligne(158, 'le carré d’abord : 4² = 16', 11, GRIS)}

  <!-- 4. le résultat -->
  ${ligne(196, gras('48', ORANGE), 22)}
  ${ligne(216, 'puis 3 × 16 = 48', 11, GRIS)}

  <!-- 5. le geste -->
  ${ligne(246, 'Le carré ne porte que sur le 4 : ce n’est pas (3 × 4)² = 144.', 12)}`,
    262,
);

// ─── Page 2 : 2x + 5 pour x = −3 ──────────────────────────────────────────

const SVG_NEGATIF = svg(
    '2x plus 5 pour x égale moins 3. Je remplace x par moins 3, entre parenthèses : 2 fois, entre parenthèses moins 3, plus 5. 2 fois moins 3 égale moins 6. Moins 6 plus 5 égale moins 1. Les parenthèses gardent le signe moins.',
    `<!-- 1. l'expression et la valeur -->
  ${ligne(40, `2${gras('x', BLEU)} + 5 pour ${gras('x', BLEU)} = ${gras('−3', ORANGE)}`, 18)}

  <!-- 2. je remplace, entre parenthèses -->
  ${ligne(80, `2 × ${gras('(−3)', ORANGE)} + 5`, 20)}
  ${ligne(100, `je remplace ${gras('x', BLEU)} par ${gras('(−3)', ORANGE)}, entre parenthèses`, 11, GRIS)}

  <!-- 3. le produit -->
  ${ligne(138, `${gras('−6')} + 5`, 20)}
  ${ligne(158, '2 × (−3) = −6', 11, GRIS)}

  <!-- 4. le résultat -->
  ${ligne(196, gras('−1', ORANGE), 22)}
  ${ligne(216, '−6 + 5 = −1', 11, GRIS)}

  <!-- 5. le geste -->
  ${ligne(246, 'Les parenthèses gardent le signe : ce n’est pas 2 × 3 + 5 = 11.', 12)}`,
    262,
);

const AIDE = {
    pages: [
        { titre: 'Avec un carré', svg: SVG_CARRE },
        { titre: 'Avec un x négatif', svg: SVG_NEGATIF },
    ],
};

const CP_1228 = {
    flash_texte_trou_saisie: AIDE,
    valeur_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1228;
